module.exports = __webpack_public_path__ + "static/media/live_tv_outlined_white.4ffc2708.svg";